import { intersect, partial, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as CustomerId } from '../../../customer/Id';
import { Id as OrganizationId } from '../../../organization/Id';

export const Request = intersect(
	struct({
		name: iotsUtils.NotEmptyString,
	})
)(
	partial({
		organizationId: OrganizationId,
		customerId: CustomerId,
	})
);
